import * as v from 'valibot';
import { SelfregSessionSchema } from '@api/io/selfreg.io';

const SelfenrollmentStatus = v.fallback(
  v.union([
    v.literal('member'), // user got enrolled
    v.literal('requested'), // user is requested to be enrolled.
    v.literal('alreadymember'), // user is already enrolled.
    v.literal('waitlistmember'), // user is on the waitlist
    v.literal('overlimit'), // enrollment limit is reached.
    v.literal('unknown'),
  ]),
  'unknown',
);

export const SelfenrollmentRequestSchema = v.object({
  status: SelfenrollmentStatus,
  session: SelfregSessionSchema,
});

export type TSelfenrollmentStatus = v.Output<typeof SelfenrollmentStatus>;
